export const DEFAULT_PAGELIST_ID = "2ded7d672a3aa111ed1bedf64314b1c14fcb"
export const DEFAULT_PAGEDETAIL_ID = "982bd8fc6b371311ed2b98463d0c7ad16b23"
export const CATEGORY_MODE =  {
  SAME: 'same_tab',
  DIFF: 'diff_tab'
}

export const TYPE_FIELD_MAPPING = [
  {
    label: '标题',
    value: 'name'
  },
  {
    label: '副标题',
    value: 'alias'
  },
  {
    label: '图片',
    value: 'iconUrl'
  },
  {
    label: '广告图',
    value: 'topUrl'
  },
  {
    label: '选中背景',
    value: 'backgroundUrl'
  }
]

// 云舟数据源type集合
export const YZ_DATACENTER_TYPES = [{
  id: 28,
  name: '云舟文献'
}, {
  id: 27,
  name: '云舟资讯'
}, {
  id: 35,
  name: '云舟教参'
}, {
  id: 45,
  name: '云舟教参2'
}, {
  id: 42,
  name: '云舟机构库'
}, {
  id: 53,
  name: '云舟学者库'
}, {
  id: 50,
  name: '云舟教参咨询'
}, {
  id: 56,
  name: '云舟学科'
}]
